import { Component, Input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-asset-error',
  templateUrl: './asset-error.component.html',
  styleUrls: ['./asset-error.component.scss'],
  imports: [ButtonModule, TranslateModule],
})
export class AssetErrorComponent {
  @Input({ required: true }) errorTitle: string;
  @Input({ required: true }) errorDetails: string;
  @Input() icon = 'sentiment_dissatisfied';
  @Input() showNavLink = true;

  reloadApp() {
    window.location.replace('/');
  }
}
